import React, { useState } from 'react'
import { Checkbox, Tabs } from "antd"
import pluralize from 'pluralize'
import Select from 'react-select'
import Createable from 'react-select/creatable'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'
import NewInventoryItem from './newinventoryitem'

import { useListData, usePet, useToggle } from '../../modules'

const { TabPane } = Tabs

const Request = ({ toggle, visible, request: rq, onPerform }) => {
    const [request, setRequest] = useState([])
    const [single, setSingle] = useState()
    const [quantity, setQuantity] = useState(0)

    const [{ loading, error }, viewRequest] = usePet('viewRequest', {
        id: rq?._id
    }, { notify: true, callback: ({ data }) => setRequest(data) })

    const onComplete = ({ }, notif, ops) => {
        notif('Items have been issued', ops('success'))
        viewRequest()
    }

    const [{ loading: issLoading }, issueRequests] = usePet('issueRequests', {
        parent: rq?._id,
        reqId: single,
        quantity
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Issuing items...' } })

    const onDComplete = ({ }, notif, ops) => {
        notif('Request has been discarded', ops('success'))
        viewRequest()
    }

    const [{ loading: discLoading }, discardRequest] = usePet('discardRequest', {
        parent: rq?._id,
        reqId: single
    }, { notify: true, callback: onDComplete, manual: true, load: { msg: 'Discarding request...' } })

    return (
        <Modal
            h="h-auto"
            w="w-4/5 md:w-3/5 xl:w-2/5 mt-5"
            align="items-start"
            title="Request"
            toggle={toggle}
            visible={visible}>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Request" key="1">
                    <Receive
                        error={error}
                        loading={loading}
                        progress>
                        {
                            request?.requests?.length > 0 ?
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2 pl-4 text-center">
                                                <div className="font-semibold">No.</div>
                                            </th>
                                            <th className="p-2 pl-4 text-left">
                                                <div className="font-semibold">Item</div>
                                            </th>
                                            <th className="p-2 text-left">
                                                <div className="font-semibold">Quantity</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            request.requests.map((rq, key) =>
                                                <tr>
                                                    <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                                    <td className="p-2 pl-4 h-5">{rq.item.name}</td>
                                                    <td className="p-2 pl-4 h-5">{rq.quantity}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                                : <div className="align-center flex w-full">
                                    <h2>No items have been requested</h2>
                                </div>
                        }
                    </Receive>
                </TabPane>
                <TabPane tab="Items Issued" key="2">
                    <Receive
                        error={error}
                        loading={loading}
                        progress>
                        {
                            request?.requests?.length > 0 ?
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2 pl-4 text-center">
                                                <div className="font-semibold">No.</div>
                                            </th>
                                            <th className="p-2 pl-4 text-left">
                                                <div className="font-semibold">Item</div>
                                            </th>
                                            <th className="p-2 text-left">
                                                <div className="font-semibold">Quantity Issued</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            request.requests.map((rq, key) =>
                                                <tr>
                                                    <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                                    <td className="p-2 pl-4 h-5">{rq.item.name}</td>
                                                    <td className="p-2 pl-4 h-5">
                                                        {
                                                            rq.issued ? `${rq.qtyIssued} ${pluralize(rq.item.receivedIn.toLowerCase(), rq.qtyIssued)}`
                                                            : rq.discarded ? 
                                                                <div className="text-yellow-500">Discarded</div>
                                                            :
                                                                <span className="flex items-center justify-center">
                                                                    <input
                                                                        className="appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mr-2 leading-tight focus:outline-none focus:bg-white"
                                                                        // id="grid-qty-item"
                                                                        defaultValue={rq.quantity}
                                                                        onChange={ e => setQuantity(e.target.value, key) }
                                                                        placeholder={`How many ${rq.item.receivedIn.toLowerCase()}?`}
                                                                        type="number" />
                                                                    <button onClick={ () => {
                                                                        setSingle(rq._id)
                                                                        issueRequests()
                                                                    } } className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">Issue</button>
                                                                    <button onClick={ () => {
                                                                        setSingle(rq._id)
                                                                        discardRequest()
                                                                    } } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">Discard</button>
                                                                </span>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                                : <div className="align-center flex w-full">
                                    <h2>No items have been requested</h2>
                                </div>
                        }
                    </Receive>
                </TabPane>
            </Tabs>
            <div className="flex justify-end">
                <button disabled={loading} onClick={toggle} className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default Request